<button>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="10"
    viewBox="0 0 13 11"
  >
    <path
      fill-rule="evenodd"
      d="M9 0v10L4.8 6.9v.107H2v-4.2h2.8V3.1L9 .001zm2.279 3.28c.437.368.722.912.722 1.527 0 .616-.285 1.16-.722 1.526l-.73-.713a.981.981 0 0 0 .452-.813.982.982 0 0 0-.451-.813l.729-.713z"
    />
  </svg>
</button>

<div class="sound-indicator-wrapper">
  <i class="background-layer"></i>
  <ul>
    <li
      *ngFor="let slot of slots; let slotIndex = index"
      [ngClass]="{ active: slot > 0 ? true : false }"
    ></li>
  </ul>
</div>
